import React from 'react'
import PropTypes from 'prop-types'
import {defineMessage} from 'react-intl'
import useOcapiSite from '../../hooks/useOcapiSite'
import TextAndLink from './text-and-links'

const D2BProgramLinks = ({variant}) => {
    const {d2bRegistrationLink, d2bEnabled} = useOcapiSite()

    return (
        <>
            {!variant && d2bEnabled && (
                <TextAndLink
                    textColor="stokkeCore.black"
                    href={d2bRegistrationLink}
                    message={defineMessage({
                        id: 'register_form.create_business_account',
                        defaultMessage:
                            '<textlink>StokkePro for Businesses, create an account here and discover your exclusive advantage.</textlink>'
                    })}
                />
            )}
        </>
    )
}

D2BProgramLinks.propTypes = {
    variant: PropTypes.string
}

export default D2BProgramLinks
